import { demoFile, feature } from "system/demo";

demoFile('feature/topic/topic-config');

feature('Topic Config', {
    structureKey: 'topic',
    features: {topic_config: true},
    state: {globals: {name: 'Godzilla'}}
});
